import { Loading } from '@/components/Atoms/Loading/Loading';
import styled from 'styled-components';

/**
 * A loader to be used to indicate something is occurring.
 * @constructor
 */
export const SubmittingAnimation = styled(Loading)`
    padding: 4px 0 var(--size-grid-unit);
`;
